import * as React from 'react';
import styled from 'styled-components';

export const LeftSideWrapper = styled.div`
  width: 447px;
  position: relative;
`;
